import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { StyledBootstrapCol } from './style.js'

const SideImage = props => {
	return <StyledBootstrapCol lg={6} />
}

export default SideImage
